<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card card-default">
                <service-wizard-layout
                    title=""
                    subtitle=""
                    :parts="parts"
                    :onComplete="onComplete"
                    :validateStep="validateStep"
                >
                <template v-slot:monitoringConfig>
                    <form novalidate data-vv-scope="monitoringConfig">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group" :class="{'has-error': errors.has('monitoringConfig.description')}">
                                    <label>Description</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="description"
                                        v-model="filledInSaleDefinition.requiredObjs.monitoringConfig.description"
                                        v-validate="'required'" 
                                    />
                                    <span class="has-error" v-if="errors.has('monitoringConfig.description')">
                                        {{errors.first('monitoringConfig.description')}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group" :class="{'has-error': errors.has('monitoringConfig.packageNumber')}">
                                    <label>Package</label>
                                    <v-select
                                        :options="filledInSaleDefinition.selectableOptions.monitoringPackage"
                                        placeholder="Select a package"
                                        name="packageNumber"
                                        :get-option-label="getLabel"
                                        v-model="filledInSaleDefinition.requiredObjs.monitoringConfig.basicPackageNumber"
                                        valueProp="basicPackageNumber"
                                        v-validate="'required'" 
                                    >
                                    </v-select>
                                    <span class="has-error" v-if="errors.has('monitoringConfig.packageNumber')">
                                        {{errors.first('monitoringConfig.packageNumber')}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </form>
                </template>
                </service-wizard-layout>
            </div>
        </div>
    </div>
</template>

<script>
import ServiceWizardLayout from '@/layouts/ServiceWizardLayout';

export default {
    components: {
        ServiceWizardLayout
    },
    props: {
        emptySaleDefinition: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            clientNumber: null,
            sales: [],
            parts: [
                {
                    name: "monitoringConfig",
                    displayName: "Monitoring Service Details",
                    icon: "fa-solid fa-gauge"
                }
            ],
            filledInSaleDefinition: {
                requiredObjs: {
                    monitoringConfig: {}
                },
                selectableOptions: {
                    monitoringPackage: []
                }
            }
        }
    },
    mounted() {        
        this.clientNumber = this.$route.params.clientNumber;
        this.filledInSaleDefinition = this.emptySaleDefinition;
    },
    methods: {
        onComplete() {
            this.filledInSaleDefinition.requiredObjs.monitoringConfig.basicPackageNumber = parseInt(this.filledInSaleDefinition.requiredObjs.monitoringConfig.basicPackageNumber);
            this.$emit("createSale", this.filledInSaleDefinition);
        },
        validateStep(scope) {
            return this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        getLabel(data) {
            return `${data.description}`;
        },
    }
}
</script>
